import { useMemo } from 'react';
import { Content } from '../Content';
import { useRestaurant } from '../../../contexts/restaurant.context';
import { usePreset, useSetPreset } from '../preset.context';
import { orderTypeScreen, orderTypes, presetStatus } from '../constants';

export const OrderTypeScreen = () => {
    const restaurant = useRestaurant();
    
    const { preset: { orderType: currentOrderType } } = usePreset();
    const setPreset = useSetPreset();
    
    const types = useMemo(() => {
        if (!restaurant) {
            return [];
        }
        
        const { delivery_method } = restaurant;
        
        return orderTypes.filter((orderType) => delivery_method.includes(orderType.id));
    }, [restaurant]);
    
    const handleSetOrderType = (orderType) => () => {
        const nextScreen = orderTypeScreen[orderType];
        
        setPreset((prevState) => ({
            ...prevState,
            ...(!!nextScreen && { currentScreen: nextScreen }),
            ...(!nextScreen && { status: presetStatus.COMPLETED }),
            preset: {
                ...prevState.preset,
                orderType,
            },
        }));
    };
    
    return (
        <Content title="Choose Order Type">
            <div className="d-flex flex-column w-100">
                {types.map((orderType) => (
                    <OrderTypeButton
                        key={orderType.id}
                        name={orderType.name}
                        description={orderType.description}
                        checked={currentOrderType === orderType.id}
                        onClick={handleSetOrderType(orderType.id)}
                    />
                ))}
            </div>
        </Content>
    )
};

const OrderTypeButton = ({ name, description = '', checked = false, onClick }) => {
    return (
        <button type="button" className="unset-button delivery-button" onClick={onClick}>
            <div className="delivery-icon">
                <i className="fas fa-dolly"></i>
            </div>
            <div className="delivery-info">
                <h4 className="font-weight-bold">{name}</h4>
                {!!description && (
                    <p className="font-italic font-weight-normal">{description}</p>
                )}
            </div>
            <div className="delivery-next-button">
                {!checked && (
                    <i className="fas fa-chevron-right"></i>
                )}
                {checked && (
                    <i className="fas fa-check text-success"></i>
                )}
            </div>
        </button>
    )
};
